import Swiper from 'swiper'

class MySwiper {
	constructor() {
		this._init()
	}
	_init() {
		this.el = document.querySelector('[data-glide]')

		if(!this.el) {
			return
		}

		const loop = ("glideLoop" in this.el.dataset) ? this.el.dataset.glideLoop == 'true' : true

		// if only one child, then don't need slideshow
		// if (this.el.querySelector('.swiper-wrapper').children.length === 1) {
		//	return
		// }

		let type = this.el.getAttribute('data-glide')
		let options = {
			loop: loop,
			autoplay: {
			  delay: 5000,
			  disableOnInteraction: false,
			}
		}

		if ('product' === type) {
			options = {
				/*
				zoom: {
					maxRatio: 2
				},
				loop: false,
				simulateTouch: false,
				*/
				/*
				autoplay: {
				  delay: 5000,
				  disableOnInteraction: false,
				}
				*/
			}
		}

		this.bindThumbnails()

		this.swiper = new Swiper('.swiper-container', options)

		// window.addEventListener('swiperUpdate', () => {
		//     console.log('swiperUpdate')
		//     // this.swiper.update()
		// })

		this.swiper.on('slideChange', () => {
			this.setCleanThumbnails()
			this.setActiveThumbnails(this.swiper.realIndex)
			this.swiper.zoom.out()
		})
		this.swiper.on('zoomChange', (scale, imageEl, slideEl) => {
			if (scale > 1 && !imageEl.src.includes('1320w')){
				imageEl.src = imageEl.dataset.srcZoom
			}
		})

		const swiperSlide = document.getElementsByClassName('swiper-zoom-container')
		for (let index = 0; index < swiperSlide.length; index++) {
			(function() {
				const el = swiperSlide[index]
				const elImg = el.querySelector('img')

				el.addEventListener('mouseover', (t) => {
					if (window.matchMedia("(max-width: 1024px)").matches)
						return
					this.swiper.zoom.in()
				})

				el.addEventListener('mouseout', (t) => {
					if (window.matchMedia("(max-width: 1024px)").matches)
						return
					this.swiper.zoom.out()
				})

				el.addEventListener('mousemove', (t) => {
					if (window.matchMedia("(max-width: 1024px)").matches)
						return
					const mouseX = t.offsetX,
						mouseY = t.offsetY

					const a = mouseX - el.getBoundingClientRect().width / 2,
						l = mouseY - el.getBoundingClientRect().height / 2

					const u = a / el.getBoundingClientRect().width,
						c = l / el.getBoundingClientRect().height

					const h = -(elImg.getBoundingClientRect().width - el.getBoundingClientRect().width) * u,
						_ = -(elImg.getBoundingClientRect().height - el.getBoundingClientRect().height) * c

					elImg.style.transform = [
						['translate3d(', h, 'px, ', _, 'px, 0)'].join(''),
						'scale(2)'
					].join(' ')
				})
			}).call(this)
		}
	}

	bindThumbnails() {
		this.thumbnails = document.querySelector('[data-glide-el=thumbnail]')

		if (!this.thumbnails) {
			return
		}

		this.thumbnails.addEventListener('click', (evt) => {
			var path = evt.path || (evt.composedPath && evt.composedPath());
			const el = path.find(el => {
				return typeof el.matches === 'function' && el.matches('li')
			})

			if (!el)
				return

			const idx = Array.from(this.thumbnails.children).indexOf(el)

			this.swiper.slideTo(idx)
		}, { capture: true })

		this.setActiveThumbnails(0)
	}

	setCleanThumbnails() {
		if (!this.thumbnails) {
			return
		}

		Array.from(this.thumbnails.children).forEach(e => e.classList.remove('glide__bullet--active'));
	}

	setActiveThumbnails(index) {
		if (!this.thumbnails) {
			return
		}

		const item = this.thumbnails.children.item(index)
		if (item) {
			item.classList.add('glide__bullet--active')
		}
	}
}

export default MySwiper